export default "__VITE_ASSET__5plYrPN8__"